export default "__VITE_ASSET__aVibvlzv__"